/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_auth_min_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum 8 characters`)
};

const es_auth_min_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mínimo 8 caracteres`)
};

const de_auth_min_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestens 8 Zeichen`)
};

const nl_auth_min_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimaal 8 tekens`)
};

const fr_auth_min_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum 8 caractères`)
};

const it_auth_min_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimo 8 caratteri`)
};

const pt_br2_auth_min_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mínimo de 8 caracteres`)
};

const pt_auth_min_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mínimo de 8 caracteres`)
};

const ja_auth_min_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最低8文字`)
};

const zh_auth_min_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最少8个字符`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const auth_min_password = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.auth_min_password(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("auth_min_password", locale)
	if (locale === "en") return en_auth_min_password(inputs)
	if (locale === "es") return es_auth_min_password(inputs)
	if (locale === "de") return de_auth_min_password(inputs)
	if (locale === "nl") return nl_auth_min_password(inputs)
	if (locale === "fr") return fr_auth_min_password(inputs)
	if (locale === "it") return it_auth_min_password(inputs)
	if (locale === "pt-BR") return pt_br2_auth_min_password(inputs)
	if (locale === "pt") return pt_auth_min_password(inputs)
	if (locale === "ja") return ja_auth_min_password(inputs)
	return zh_auth_min_password(inputs)
};